import api from 'src/config/api';
import {
	IGetQuestionnaireTemplatesRequestParams,
	IQuestionnaireTemplateRequest,
	IQuestionnaireTemplateResponse,
	IQuestionnaireTemplate,
} from 'src/features/questionnaire_template/domain/types';

export const annotationTemplateApi = {
	createAnnotationTemplate: async (
		annotationTemplateData: IQuestionnaireTemplateRequest,
		siteSlug: string,
	): Promise<IQuestionnaireTemplateResponse> => {
		const response = await api.post(
			'/api/v1/annotation-template',
			annotationTemplateData,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},

	getAnnotationTemplate: async (
		annotationTemplateId: number,
		siteSlug: string,
	): Promise<IQuestionnaireTemplateResponse> => {
		const response = await api.get(
			`/api/v1/annotation-template/${annotationTemplateId}`,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},

	getAnnotationTemplates: async (
		requestParams: IGetQuestionnaireTemplatesRequestParams,
		siteSlug: string,
	): Promise<IQuestionnaireTemplate[]> => {
		const { sort, order, only_published } = requestParams;

		const params = new URLSearchParams({
			...(sort && order && { sort, order }),
			...(only_published !== undefined && {
				only_published: String(only_published),
			}),
		});

		const response = await api.get(
			`/api/v1/annotation-templates?${params}`,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},

	deleteAnnotationTemplate: async (
		annotationTemplate: IQuestionnaireTemplate,
		siteSlug: string,
	): Promise<void> => {
		await api.post(
			'/api/v1/annotation-template',
			{
				id: annotationTemplate.id,
				name: annotationTemplate.name,
				published: annotationTemplate.published,
				index: annotationTemplate.index,
				is_updated: false,
				is_deleted: true,
				sections: [],
			},
			{
				headers: { Site: siteSlug },
			},
		);
	},
};
